import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';
import Avatar, { AvatarProps } from '@mui/material/Avatar';
import { getColorForUnique } from 'utils/colors';
import { getUserInitials } from 'utils/helper';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'fit';
export type AvatarVariant = 'square' | 'rounded' | 'circular';

  type Props = Pick<AvatarProps, 'classes' | 'variant'> & {
    size?: AvatarSize;
    placeholder?: string;
    src?: string;
    alt?: string;
    actions?: ReactNode;
    children?: ReactNode;
    color?: string;
  };

const sizes = {
  xs: [20, 10],
  sm: [24, 11],
  md: [40, 18],
  lg: [56, 24],
  xl: [72, 32],
  xxl: [96, 36],
  fit: ['100% !important', 32],
};

export default function Image({
  placeholder,
  size = 'sm',
  src,
  alt,
  children,
  variant = 'circular',
  classes: _classes,
  color,
}: Props) {
  const [wh, fontSize] = sizes[size];
  const classes = {
    ..._classes,
    root: clsx({
      'flex-1': size === 'fit',
    }),
    img: clsx({
      '!object-contain !w-[initial] !max-h-full': size === 'fit',
      'object-fill': size !== 'fit',
    }),
  };
  const initials = getUserInitials(alt ?? '');
  return (
    <Avatar
      sx={{
        width: size === 'fit' ? '100%' : wh,
        height: size === 'fit' ? 'auto' : wh,
        fontSize,
        bgcolor: color ?? getColorForUnique(alt ?? ''),
      }}
      classes={classes}
      src={src ?? placeholder}
      alt={alt}
      variant={variant}
    >
      {children ?? initials}
    </Avatar>
  );
}
